// Core
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import Slider from 'react-slick';
import { Box, Text, Button, Image, useBreakpointValue } from '@chakra-ui/react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { NavLink, Link } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';
import { parseFullDate } from 'services/Utils';
import placeholder from 'assets/img/placeholder-giveaways.jpg';

// Components
import Card from 'components/Card/Card';
import { ReviewsIcon, LeftIcon, RightIcon } from 'components/Icons/Icons';
import Countdown from 'components/Timers/Countdown';

const BannerItem = ({ image, date }) => {    
	return (
		<>
			<Image src={image ?? placeholder} 
                objectFit="cover" 
                objectPosition="right"
                h={{sm: '200px', sm: '280px', md: '100%'}} />
			{ date && (
				<Countdown declareDate={date} top="unset" bottom="16px" right="16px" />
			)}
		</>
	);
};

const BannerBox = ({ item, objectType }) => {    
    return (
        <Box
            borderRadius="16px"
            minW={{sm: '100%'}}
            h={{sm: '200px', sm: '280px', md: '473px'}}
            overflow="hidden"
            display="flex"
            bg="#0e1b3b"
            alignItems="center"
            justifyContent="center"
            position="relative"
            mt={{base: '20px', md: '67px'}}>
            { (objectType === 'giveaways' && item?.objectId) ? (
                <NavLink to={`/giveaways/${item.objectId}`}>
                    <BannerItem image={item.image} date={item?.date} />
                </NavLink>
            ) : (
                <BannerItem image={item.image} date={item?.date} />
            )}
        </Box>
    );
};

const Banners = ({ type, objectType, objectId }) => {
	const [data, setData] = useState([]);
	const [active, setActive] = useState(0);

    const { isLoading } = useQuery({
        queryKey: ['banners'],
        queryFn: async () => {
        	let params = {
        		limit: 25, 
        		offset: 0
        	};

        	if(type) { params = {...params, type}; }
        	if(objectType) { params = {...params, objectType}; }
        	if(objectId) { params = {...params, objectId}; }

            const response = await apiService.getBanners(params);
            setData(response.data);
            return true;
        },
        refetchOnWindowFocus: false
    });

    const settings = {
        dots: true, 
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0%',
        autoplay: true,
        autoplaySpeed: 3000
    };

    const isMobile = useBreakpointValue({
        base: true, 
        md: false 
    });

    return (
        <Box overflow="hidden" className={ !isMobile ? 'banner-slider' : 'banner-slider banner-slider-mobile' }> 
          { isLoading ? (<></>) : (
            <>{ data?.length > 1 ? 
                <Slider {...settings}>
                    { data.map((item, index) => (
                        <BannerBox key={index} item={item} objectType={objectType} />
                    ))}
                </Slider>
                : data?.length === 1 ?
                <BannerBox item={data[0]} objectType={objectType} />
                : <></>
            }</>
          )}
        </Box>
    );
};

export default Banners;
